import CustomerCreateModal from './customer-create-modal-container'

export default CustomerCreateModal
